import React, { useState, useEffect } from 'react';
import UserPermissionFormPopup from './UserPermissionFormPopup';
import { useParams } from 'react-router-dom';
import { getPermissions } from '../../../actions/organization';
import isArray from 'lodash.isarray';

const PermissionManagement = ({ subject = null }) => {
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    getPermissionsFunc();
  }, []);

  const getPermissionsFunc = async () => {
    try {
      const res = await getPermissions();
      if (res?.length > 0 && isArray(res)) {
        setPermissions([...res]);
      } else {
        setPermissions([]);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const updateHandler = () => {
    try {
      getPermissionsFunc();
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div className="page-content">
      <div className="d-flex flex-row align-items-center justify-content-between">
        <h5>User Permissions</h5>
        <UserPermissionFormPopup
          subject={subject}
          updateHandler={updateHandler}
        />
      </div>
      <div className="mt-4">
        <table className="table table-nowrap table-centered align-middle mb-0">
          <thead className="bg-light fs-14">
            <tr>
              <th>#</th>
              <th>Permission</th>
            </tr>
          </thead>
          <tbody className="fs-13">
            {permissions?.map((permission, index) => {
              return (
                <tr key={permission?._id}>
                  <td>{index + 1}</td>
                  <td className="text-capitalize">{`${permission?.name} ${permission?.subject}`}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PermissionManagement;
